import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataContextService } from '../../shared/services/datacontext.service';
import { env } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class HomeService extends DataContextService<any> { 
  constructor(http: HttpClient) {
    super(http, env.API.home_page_content_api_url);     
  }

  getData(): Observable<any> {
    return this.get(env.API.home_page_content_api_url);
  }
}
